(function() {
    'use strict';

    angular
        .module('nasracApp')
        .controller('NasracProviderDeleteController',NasracProviderDeleteController);

    NasracProviderDeleteController.$inject = ['$uibModalInstance', 'entity', 'NasracProvider'];

    function NasracProviderDeleteController($uibModalInstance, entity, NasracProvider) {
        var vm = this;

        vm.nasracProvider = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id, providerType) {
            NasracProvider.delete({id: id, providerType: providerType},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
